var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "leave-active-class": "duration-200"
    }
  }, [_vm.showing === true && _vm.loadingData === false ? _c('div', {
    staticClass: "z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center",
    on: {
      "keydown": function ($event) {
        return _vm.$refs.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.$refs.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    staticClass: "fixed inset-0 transition-opacity",
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-indigo-600 bg-opacity-85"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-lg py-6 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "scroll": function ($event) {
        return _vm.$refs.progressbar.reduceProgressBar($event);
      }
    }
  }, [_c('div', {
    staticClass: "cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600",
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.messageHeader.type !== '' && _vm.messageHeader.msg !== '' ? _c('div', {
    staticClass: "absolute text-center py-5 mt-10 w-6/12 left-3/12 right-3/12 text-base flex items-center justify-center",
    class: {
      'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600': _vm.messageHeader === 'saveIsSuccess' || _vm.messageHeader === 'transferIsSuccess',
      'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600': _vm.messageHeader === 'error' || _vm.messageHeader === 'noName' || _vm.messageHeader === 'lastModule' || _vm.messageHeader === 'evaluationInProgress',
      'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600': _vm.messageHeader === 'noSave'
    }
  }, [_c('div', [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_vm.messageHeader === 'saveIsSuccess' || _vm.messageHeader === 'transferIsSuccess' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }) : _vm.messageHeader === 'error' || _vm.messageHeader === 'noName' || _vm.messageHeader === 'lastModule' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-triangle"
    }
  }) : _vm.messageHeader === 'noSave' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-triangle"
    }
  }) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'saveIsSuccess' ? _c('div', [_vm._v("\n                  Vos données ont été enregistrées.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'transferIsSuccess' ? _c('div', [_vm._v("\n                  Le référentiel de formation à bien été transférée.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'evaluationInProgress' ? _c('div', [_vm._v("\n                  Vous ne pouvez pas modifier un référentiel de formation\n                  utilisée par une évaluation.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'error' ? _c('div', [_vm._v("\n                  Erreur d'enregistrement des données.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'lastModule' ? _c('div', [_vm._v("\n                  Vous ne pouvez pas supprimer le dernier domaine.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'noName' ? _c('div', [_vm._v("\n                  Veuillez remplir le champ \"nom de la formation\""), _c('br'), _vm._v("\n                  pour enregistrer le référentiel.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader === 'noSave' ? _c('div', [_vm._v("\n                  Vous avez des modifications non sauvegardées."), _c('br')]) : _vm._e()], 1), _vm._v(" "), _vm.messageHeader === 'noSave' ? _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4",
    on: {
      "click": function ($event) {
        return _vm.cancel_nosave();
      }
    }
  }, [_vm._v("\n                  ANNULER\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2",
    on: {
      "click": function ($event) {
        return _vm.closeWithoutSaving();
      }
    }
  }, [_vm._v("\n                  QUITTER\n                ")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm.editable && _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER) ? _c('div', {
    staticClass: "absolute right-15 mt-13 flex items-center justify-center"
  }, [_vm.saving ? _c('div', {
    staticClass: "w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
  }, [_c('span', {
    staticClass: "h-6 w-6 ml-4 mt-1/4 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14",
    on: {
      "click": _vm.save_datas
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1)]) : !_vm.editable && _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER) ? _c('div', {
    staticClass: "absolute right-15 mt-13 flex items-center justify-center"
  }, [_vm.saving ? _c('div', {
    staticClass: "w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
  }, [_c('span', {
    staticClass: "h-6 w-6 ml-4 mt-1/4 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14",
    on: {
      "click": _vm.save_datas
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _vm.editable ? _c('progress-bar', {
    ref: "progressbar",
    staticClass: "mx-6",
    attrs: {
      "in-popup": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 my-5 md:my-15"
  }, [_vm.form.nom_du_poste === '' || _vm.form.nom_du_poste == null ? _c('h3', {
    staticClass: "col-span-full"
  }, [_vm._v("\n          Nouvelle formation\n        ")]) : _c('h3', {
    staticClass: "col-span-full"
  }, [_vm._v("\n          " + _vm._s(_vm.form.nom_du_poste) + "\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "col-span-full text-indigo-600 my-10"
  }, [_vm._v("\n          Informations de base\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mx-5 md:mx-15 col-span-full grid grid-cols-12 gap-4"
  }, [_c('input-text', {
    class: 'lg:col-span-4',
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "value": _vm.form.nom_du_poste,
      "libelle": "Nom de la formation",
      "name": "nom_du_poste"
    },
    on: {
      "input": function (newValue) {
        _vm.form.nom_du_poste = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "datas": _vm.categories,
      "disabled": !_vm.editable,
      "necessary": true,
      "value": _vm.form.sector,
      "libelle": "Secteur d'activité",
      "name": "sector"
    },
    on: {
      "input": function (newValue) {
        _vm.form.sector = newValue;
        _vm.setIndex(newValue);
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "datas": _vm.listFamilies,
      "disabled": !_vm.editable,
      "necessary": true,
      "value": _vm.form.family,
      "libelle": "Famille professionnelle",
      "name": "family"
    },
    on: {
      "input": function (newValue) {
        _vm.form.family = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.evolution,
      "libelle": "Présentation de l’évolution du Titre Professionnel",
      "name": "evolution"
    },
    on: {
      "input": function (newValue) {
        _vm.form.evolution = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.contexte_exam,
      "libelle": "Contexte de l’examen du Titre Professionnel",
      "name": "contexte_exam"
    },
    on: {
      "input": function (newValue) {
        _vm.form.contexte_exam = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.def_emploi,
      "libelle": "Définition de l’emploi type",
      "name": "def_emploi"
    },
    on: {
      "input": function (newValue) {
        _vm.form.def_emploi = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.conditions_exercice,
      "libelle": "Conditions d’exercice",
      "name": "conditions_exercice"
    },
    on: {
      "input": function (newValue) {
        _vm.form.conditions_exercice = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.secteurs_accessibles,
      "libelle": "Secteurs d’activité accessibles par le détenteur du titre",
      "name": "secteurs_accessibles"
    },
    on: {
      "input": function (newValue) {
        _vm.form.secteurs_accessibles = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.type_emplois_accessibles,
      "libelle": "Types d’emplois accessibles par le détenteur du titre",
      "name": "type_emplois_accessibles"
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_emplois_accessibles = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.reglementation_activite,
      "libelle": "Réglementation d’activités (le cas échéant)",
      "name": "reglementation_activite"
    },
    on: {
      "input": function (newValue) {
        _vm.form.reglementation_activite = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.certifications_equivalentes,
      "libelle": "Equivalences avec d’autres certifications (le cas échéant)",
      "name": "certifications_equivalentes"
    },
    on: {
      "input": function (newValue) {
        _vm.form.certifications_equivalentes = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "size": 5,
      "value": _vm.form.competences_transversales,
      "libelle": "Compétences transversales de l’emploi (le cas échéant)",
      "name": "competences_transversales"
    },
    on: {
      "input": function (newValue) {
        _vm.form.competences_transversales = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "value": _vm.form.niveau,
      "libelle": "Niveau",
      "name": "niveau"
    },
    on: {
      "input": function (newValue) {
        _vm.form.niveau = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "value": _vm.form.convention,
      "libelle": "Convention",
      "name": "convention"
    },
    on: {
      "input": function (newValue) {
        _vm.form.convention = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-4",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": true,
      "value": _vm.form.nsf,
      "libelle": "Code(s) NSF",
      "name": "nsf"
    },
    on: {
      "input": function (newValue) {
        _vm.form.nsf = newValue;
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-indigo-600 col-span-full mt-10 mb-5"
  }, [_vm._v("\n            Référentiels correspondants\n          ")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": false,
      "value": _vm.form.rome,
      "libelle": "ROME",
      "name": "rome"
    },
    on: {
      "input": function (newValue) {
        _vm.form.rome = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": false,
      "value": _vm.form.rsfp,
      "libelle": "RSFP",
      "name": "rsfp"
    },
    on: {
      "input": function (newValue) {
        _vm.form.rsfp = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": false,
      "value": _vm.form.rncp,
      "libelle": "Diplômes et titre (RNCP)",
      "name": "rncp"
    },
    on: {
      "input": function (newValue) {
        _vm.form.rncp = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "disabled": !_vm.editable,
      "necessary": false,
      "value": _vm.form.convention_collective,
      "libelle": "Conventions collectives",
      "name": "convention_collective"
    },
    on: {
      "input": function (newValue) {
        _vm.form.convention_collective = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full mt-10"
  }, [_c('div', {
    staticClass: "my-10"
  }, [_c('div', {
    staticClass: "w-full flex flex-col justify-center items-center mb-10 mx-5 md:mx-15"
  }, [_c('div', {
    staticClass: "max-w-8/10 flex flex-col items-end"
  }, [_c('div', {
    staticClass: "flex flex-row justify-center items-center cursor-pointer w-full",
    on: {
      "click": [_vm.displayModulelist, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "flex flex-row items-end justify-center ml-2"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-center select-none"
  }, [_vm._v("\n                      " + _vm._s('Domaine ' + (_vm.currentModule + 1) + ' : ' + (_vm.form.modules[_vm.currentModule].module_name === '' ? 'Nom du domaine' : _vm.form.modules[_vm.currentModule].module_name)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
  }, [_c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "activitylist relative w-60 h-0"
  }, [_vm.showList ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayModulelist,
      expression: "displayModulelist"
    }],
    staticClass: "absolute w-full flex z-20 rounded-md bg-white shadow-md shadow-gray-600 text-sm right-0"
  }, [_c('div', {
    staticClass: "mx-5 my-3"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._l(_vm.form.modules, function (module, i) {
    return _c('div', {
      key: i,
      staticClass: "first:pt-2 py-1"
    }, [_c('p', {
      staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          _vm.currentModule = i;
        }
      }
    }, [_c('span', [_vm._v(_vm._s('Module ' + (i + 1) + ' : ' + module.module_name))])])]);
  }), _vm._v(" "), _vm.editable ? _c('div', {
    staticClass: "border-t pt-2 mt-5 text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": _vm.addModule
    }
  }, [_c('span', [_vm._v("Ajouter un domaine")])]) : _vm._e()], 2)])]) : _vm._e()])])]), _vm._v(" "), _vm.editable ? _c('div', {
    staticClass: "flex items-center mb-10 mx-5 md:mx-15"
  }, [_c('div', {
    staticClass: "flex flex-row justify-start items-center w-max cursor-pointer",
    on: {
      "click": _vm.deleteModule
    }
  }, [_c('div', {
    staticClass: "cursor-pointer relative rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "flex ml-3 text-left text-lg text-gray-600 hover:font-semibold"
  }, [_vm._v("\n                  Supprimer le domaine\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-none w-max relative"
  }, [_c('action-button', {
    attrs: {
      "bg-color": "bg-orange-300",
      "bg-color-square": "bg-orange-100",
      "border-color": "border-transparent",
      "icon": "swap",
      "icon-color": "text-orange-600",
      "libelle": "Intervertir les modules",
      "text-color": "text-gray-900"
    },
    on: {
      "clickAction": _vm.displayInvertModuleMenu
    }
  }), _vm._v(" "), _vm.isInvertModuleMenuDisplayed ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.hideInvertModuleMenu,
      expression: "hideInvertModuleMenu"
    }],
    staticClass: "z-20 absolute right-0 top-13 text-sm w-max max-w-md bg-white rounded-md shadow-md shadow-gray-600 px-6 py-5 cursor-default flex flex-col space-y-1"
  }, [_c('draggable', _vm._b({
    on: {
      "end": function ($event) {
        _vm.drag = false;
      },
      "start": function ($event) {
        _vm.drag = true;
      }
    },
    model: {
      value: _vm.form.modules,
      callback: function ($$v) {
        _vm.$set(_vm.form, "modules", $$v);
      },
      expression: "form.modules"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l(_vm.form.modules, function (module, iMod) {
    return _c('div', {
      key: 'A' + iMod
    }, [_c('div', {
      staticClass: "grid grid-cols-12 cursor-pointer items-center gap-x-2"
    }, [_c('icon', {
      staticClass: "text-indigo-600 col-span-1",
      attrs: {
        "name": "move"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-gray-600 hover:text-gray-900 col-span-11"
    }, [_vm._v("\n                            " + _vm._s(module.module_name) + "\n                          ")])], 1), _vm._v(" "), iMod < _vm.form.modules.length - 1 ? _c('hr', {
      staticClass: "my-2.5 border-indigo-300"
    }) : _vm._e()]);
  }), 0)], 1)], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm._l(_vm.form.modules, function (module, index) {
    return _c('div', {
      key: 'modulegeneral' + index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentModule === index,
        expression: "currentModule === index"
      }]
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-4 mx-5 md:mx-15"
    }, [_c('input-text', {
      staticClass: "lg:col-span-6",
      attrs: {
        "disabled": !_vm.editable,
        "necessary": true,
        "value": _vm.form.modules[index].module_name,
        "libelle": "Nom du domaine",
        "name": "module_name"
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.modules[index], 'module_name', newValue);
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-6",
      attrs: {
        "datas": _vm.tempsConsacreValues,
        "disabled": !_vm.editable,
        "name": 'temps_consacre',
        "necessary": true,
        "value": _vm.form.modules[index].module_time,
        "libelle": "Temps consacré"
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.modules[index].module_time, 'temps_consacre', newValue);
        }
      }
    }), _vm._v(" "), _c('input-text-area', {
      staticClass: "lg:col-span-6",
      attrs: {
        "disabled": !_vm.editable,
        "necessary": true,
        "size": 5,
        "value": _vm.form.modules[index].module_def,
        "libelle": "Définition du domaine",
        "name": "definition"
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.modules[index], 'module_def', newValue);
        }
      }
    }), _vm._v(" "), _c('input-text-area', {
      staticClass: "lg:col-span-6",
      attrs: {
        "disabled": !_vm.editable,
        "necessary": true,
        "size": 5,
        "value": _vm.form.modules[index].module_reglementation,
        "libelle": "Règlementation",
        "name": "reglementation"
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.modules[index], 'module_reglementation', newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mb-5 mt-15"
    }, [_c('h5', {
      staticClass: "text-left uppercase text-base text-indigo-600 mb-5 mx-5 md:mx-15"
    }, [_vm._v("\n                    Competences\n                  ")]), _vm._v(" "), _c('add-button', {
      staticClass: "mx-5 md:mx-15",
      attrs: {
        "libelle": "Ajouter une compétence",
        "disabled": !_vm.editable
      },
      on: {
        "add": function ($event) {
          return _vm.addCompetence(_vm.form.modules[index].module_competences, 'competence', index);
        }
      }
    }), _vm._v(" "), _vm.form.modules[index].module_competences.length > 0 ? _c('div', {
      staticClass: "grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32 text-lg"
    }, [_c('span', {
      staticClass: "col-start-3 col-span-4 justify-items-start text-base text-gray-500"
    }, [_vm._v("Compétences")]), _vm._v(" "), _c('span', {
      staticClass: "col-span-4 justify-items-start text-base text-gray-500"
    }, [_vm._v("Description")]), _vm._v(" "), _c('span', {
      staticClass: "col-span-2 justify-items-start text-base text-gray-500"
    }, [_vm._v("Nb. de critères")])]) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
      style: {
        'cursor:grab;': _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER)
      },
      on: {
        "start": function ($event) {
          _vm.drag = true;
        },
        "end": function ($event) {
          _vm.drag = false;
        }
      },
      model: {
        value: _vm.form.modules[_vm.currentModule].module_competences,
        callback: function ($$v) {
          _vm.$set(_vm.form.modules[_vm.currentModule], "module_competences", $$v);
        },
        expression: "form.modules[currentModule].module_competences"
      }
    }, 'draggable', _vm.dragOptionsComp, false), [_c('transition-group', {
      attrs: {
        "enter-active-class": "ease-in duration-1000",
        "enter-class": "bg-indigo-300 border-0 rounded-xl",
        "enter-to-class": "bg-none border-0 rounded-xl",
        "leave-active-class": "linear duration-1000",
        "leave-class": "h-20 opacity-100",
        "leave-to-class": "h-0 opacity-0",
        "tag": "div"
      }
    }, _vm._l(_vm.form.modules[index].module_competences, function (competence, compindex) {
      return _c('div', {
        key: 'competence' + compindex,
        staticClass: "odd:bg-indigo-200 odd:bg-opacity-50"
      }, [_c('div', {
        staticClass: "grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32",
        class: {
          'bg-indigo-200 border-l-2 border-indigo-600': _vm.itemDisplayed === compindex
        },
        attrs: {
          "id": 'item-competence-' + index + '-' + compindex
        },
        on: {
          "click": function ($event) {
            return _vm.displayItem(compindex);
          }
        }
      }, [_c('div', {
        staticClass: "col-span-1 items-center justify-self-end"
      }, [_c('icon', {
        staticClass: "text-indigo-600",
        attrs: {
          "name": "move"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-span-1 items-center justify-self-center",
        on: {
          "click": function ($event) {
            return _vm.displayItem(compindex);
          }
        }
      }, [_c('icon', {
        staticClass: "text-pink-600 transform transition-transform ease-in-out duration-300",
        class: {
          'rotate-90': _vm.itemDisplayed === compindex
        },
        attrs: {
          "name": "chevron-right"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "col-span-4 justify-items-start text-base text-gray-900"
      }, [_vm._v(_vm._s(competence.name))]), _vm._v(" "), _c('span', {
        staticClass: "col-span-4 justify-items-start text-sm text-gray-900 italic line-clamp-4"
      }, [_vm._v(_vm._s(competence.description))]), _vm._v(" "), _c('span', {
        staticClass: "col-span-2 justify-items-start text-base text-gray-900"
      }, [_vm._v(_vm._s(competence.criterions.length))])]), _vm._v(" "), _c('transition', {
        attrs: {
          "enter-active-class": "ease-out duration-300",
          "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
          "leave-active-class": "ease-in duration-200",
          "leave-class": "opacity-100 translate-y-0 sm:scale-100",
          "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.itemDisplayed === compindex,
          expression: "itemDisplayed === compindex"
        }],
        staticClass: "min-h-24 bg-white"
      }, [_c('div', {
        staticClass: "grid grid-cols-2 gap-x-4 mx-5 md:mx-15 pt-10"
      }, [_vm.editable ? _c('input-text', {
        staticClass: "lg:col-span-1",
        attrs: {
          "disabled": !_vm.editable,
          "necessary": true,
          "value": competence.name,
          "libelle": "Nom de la compétence",
          "name": "competence_name"
        },
        on: {
          "input": function (newValue) {
            competence.name = newValue;
          }
        }
      }) : _vm._e(), _vm._v(" "), _vm.editable ? _c('input-text', {
        staticClass: "lg:col-span-1",
        attrs: {
          "disabled": !_vm.editable,
          "necessary": true,
          "value": competence.description,
          "libelle": "Description",
          "name": "competence_description"
        },
        on: {
          "input": function (newValue) {
            competence.description = newValue;
          }
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "mx-5 md:mx-15"
      }, [_c('h3', {
        staticClass: "uppercase text-indigo-600 text-base text-left my-10"
      }, [_vm._v("\n                                Critères et indicateurs d'acceptation\n                              ")]), _vm._v(" "), _c('add-button', {
        staticClass: "w-max mb-5",
        attrs: {
          "libelle": "Ajouter un critère",
          "disabled": !_vm.editable
        },
        on: {
          "add": function ($event) {
            return _vm.addCritere(_vm.form.modules[index].module_competences[compindex].criterions);
          }
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "mx-5 md:mx-15"
      }, [_c('draggable', _vm._b({
        style: {
          'cursor:grab;': _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER)
        },
        on: {
          "start": function ($event) {
            _vm.drag = true;
          },
          "end": function ($event) {
            _vm.drag = false;
          }
        },
        model: {
          value: competence.criterions,
          callback: function ($$v) {
            _vm.$set(competence, "criterions", $$v);
          },
          expression: "competence.criterions"
        }
      }, 'draggable', _vm.dragOptionsCrit, false), [_c('transition-group', {
        attrs: {
          "enter-active-class": "ease-in duration-1000",
          "enter-class": "bg-indigo-300 border-0 rounded-xl",
          "enter-to-class": "bg-none border-0 rounded-xl",
          "leave-active-class": "linear duration-1000",
          "leave-class": "h-20 opacity-100",
          "leave-to-class": "h-0 opacity-0",
          "tag": "div"
        }
      }, _vm._l(competence.criterions, function (criterion, jndex) {
        return _c('div', {
          key: 'crit' + compindex + jndex,
          staticClass: "mt-5 last:mb-5"
        }, [_c('DoubleInputTextWithAction', {
          ref: 'comp' + compindex + 'criterion' + jndex,
          refInFor: true,
          style: 'cursor:grab',
          attrs: {
            "libelle-left": "Critère",
            "libelle-right": "Indicateur",
            "necessary": true,
            "value-left": criterion.name,
            "value-right": criterion.indicateur,
            "disabled": !_vm.editable,
            "is-grabable": true,
            "draggable": true,
            "prefix-text-left": jndex + 1 + '. ',
            "prefix-text-right": jndex + 1 + '. '
          },
          on: {
            "inputLeft": function (newValue) {
              criterion.name = newValue;
            },
            "inputRight": function (newValue) {
              criterion.indicateur = newValue;
            },
            "duplicate": function ($event) {
              _vm.form.modules[index].module_competences[compindex].push(criterion);
            },
            "delete": function ($event) {
              return _vm.deleteFromModule(_vm.form.modules[index].module_competences[compindex].criterions, jndex);
            },
            "switchEditable": function (state) {
              _vm.changeDraggableCriterionState('competence', compindex, jndex, state);
            }
          }
        })], 1);
      }), 0)], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "mx-5 md:mx-15 mt-10"
      }, [_vm.editable ? _c('div', {
        staticClass: "w-max",
        on: {
          "click": function ($event) {
            return _vm.deleteFromModule(_vm.form.modules[index].module_competences, compindex);
          }
        }
      }, [_c('delete-button', {
        attrs: {
          "libelle": "Supprimer la compétence"
        }
      })], 1) : _vm._e()])])])], 1);
    }), 0)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "mb-5 mt-15"
    }, [_c('h5', {
      staticClass: "text-left uppercase text-base text-indigo-600 mb-5 mx-5 md:mx-15"
    }, [_vm._v("\n                    Competences transversales\n                  ")]), _vm._v(" "), _c('add-button', {
      staticClass: "mx-5 md:mx-15",
      attrs: {
        "libelle": "Ajouter une compétence transversale",
        "disabled": !_vm.editable
      },
      on: {
        "add": function ($event) {
          return _vm.addCompetence(_vm.form.modules[index].module_competences_transversales, 'competence-transversale', index);
        }
      }
    }), _vm._v(" "), _vm.form.modules[index].module_competences_transversales.length > 0 ? _c('div', {
      staticClass: "grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32 text-lg"
    }, [_c('span', {
      staticClass: "col-start-3 col-span-4 justify-items-start text-base text-gray-500"
    }, [_vm._v("Compétences")]), _vm._v(" "), _c('span', {
      staticClass: "col-span-4 justify-items-start text-base text-gray-500"
    }, [_vm._v("Description")]), _vm._v(" "), _c('span', {
      staticClass: "col-span-2 justify-items-start text-base text-gray-500"
    }, [_vm._v("Nb. de critères")])]) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
      style: {
        'cursor:grab;': _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER)
      },
      on: {
        "start": function ($event) {
          _vm.drag = true;
        },
        "end": function ($event) {
          _vm.drag = false;
        }
      },
      model: {
        value: _vm.form.modules[index].module_competences_transversales,
        callback: function ($$v) {
          _vm.$set(_vm.form.modules[index], "module_competences_transversales", $$v);
        },
        expression: "\n                      form.modules[index].module_competences_transversales\n                    "
      }
    }, 'draggable', _vm.dragOptionsCompTr, false), [_c('transition-group', {
      attrs: {
        "enter-active-class": "ease-in duration-1000",
        "enter-class": "bg-indigo-300 border-0 rounded-xl",
        "enter-to-class": "bg-none border-0 rounded-xl",
        "leave-active-class": "linear duration-1000",
        "leave-class": "h-20 opacity-100",
        "leave-to-class": "h-0 opacity-0",
        "tag": "div"
      }
    }, _vm._l(_vm.form.modules[index].module_competences_transversales, function (competence_transversales, lndex) {
      return _c('div', {
        key: 'competenceTR' + lndex,
        staticClass: "odd:bg-indigo-200 odd:bg-opacity-50"
      }, [_c('div', {
        staticClass: "grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32",
        class: {
          'bg-indigo-200 border-l-2 border-indigo-600': _vm.compTrDisplayed === lndex
        },
        attrs: {
          "id": 'item-competence-transversale-' + index + '-' + lndex
        },
        on: {
          "click": function ($event) {
            return _vm.displayCompTr(lndex);
          }
        }
      }, [_c('div', {
        staticClass: "col-span-1 justify-self-end"
      }, [_c('icon', {
        staticClass: "text-indigo-600",
        attrs: {
          "name": "move"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-span-1 justify-self-center"
      }, [_c('icon', {
        staticClass: "text-pink-600 transform transition-transform ease-in-out duration-300",
        class: {
          'rotate-90': _vm.compTrDisplayed === lndex
        },
        attrs: {
          "name": "chevron-right"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "col-span-4 justify-items-start text-base text-gray-900"
      }, [_vm._v(_vm._s(competence_transversales.name))]), _vm._v(" "), _c('span', {
        staticClass: "col-span-4 justify-items-start text-sm text-gray-900 italic line-clamp-4"
      }, [_vm._v(_vm._s(competence_transversales.description))]), _vm._v(" "), _c('span', {
        staticClass: "col-span-2 justify-items-start text-base text-gray-900"
      }, [_vm._v(_vm._s(competence_transversales.criterions.length))])]), _vm._v(" "), _c('transition', {
        attrs: {
          "enter-active-class": "ease-out duration-300",
          "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
          "leave-active-class": "ease-in duration-200",
          "leave-class": "opacity-100 translate-y-0 sm:scale-100",
          "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        }
      }, [_vm.compTrDisplayed === lndex ? _c('div', {
        staticClass: "min-h-24 bg-white"
      }, [_c('div', {
        staticClass: "grid grid-cols-2 gap-x-4 mx-5 md:mx-15 pt-10"
      }, [_vm.editable ? _c('input-text', {
        staticClass: "lg:col-span-1",
        attrs: {
          "disabled": !_vm.editable,
          "necessary": false,
          "value": competence_transversales.name,
          "libelle": "Nom de la compétence",
          "name": "competence_name"
        },
        on: {
          "input": function (newValue) {
            competence_transversales.name = newValue;
          }
        }
      }) : _vm._e(), _vm._v(" "), _vm.editable ? _c('input-text', {
        staticClass: "lg:col-span-1",
        attrs: {
          "disabled": !_vm.editable,
          "necessary": false,
          "value": competence_transversales.description,
          "libelle": "Description",
          "name": "competence_description"
        },
        on: {
          "input": function (newValue) {
            competence_transversales.description = newValue;
          }
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "mx-5 md:mx-15"
      }, [_c('h3', {
        staticClass: "uppercase text-indigo-600 text-base text-left my-10"
      }, [_vm._v("\n                                Critères et indicateurs d'acceptation\n                              ")]), _vm._v(" "), _c('add-button', {
        staticClass: "w-max mb-5",
        attrs: {
          "libelle": "Ajouter un critère",
          "disabled": !_vm.editable
        },
        on: {
          "add": function ($event) {
            return _vm.addCritere(_vm.form.modules[index].module_competences_transversales[lndex].criterions);
          }
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "mx-5 md:mx-15"
      }, [_c('draggable', _vm._b({
        style: {
          'cursor:grab;': _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER)
        },
        on: {
          "start": function ($event) {
            _vm.drag = true;
          },
          "end": function ($event) {
            _vm.drag = false;
          }
        },
        model: {
          value: competence_transversales.criterions,
          callback: function ($$v) {
            _vm.$set(competence_transversales, "criterions", $$v);
          },
          expression: "competence_transversales.criterions"
        }
      }, 'draggable', _vm.dragOptionsCritTr, false), [_c('transition-group', {
        attrs: {
          "enter-active-class": "ease-in duration-1000",
          "enter-class": "bg-indigo-300 border-0 rounded-xl",
          "enter-to-class": "bg-none border-0 rounded-xl",
          "leave-active-class": "linear duration-1000",
          "leave-class": "h-20 opacity-100",
          "leave-to-class": "h-0 opacity-0",
          "tag": "div"
        }
      }, _vm._l(competence_transversales.criterions, function (criterion_transversales, kndex) {
        return _c('div', {
          key: 'critTR' + lndex + kndex,
          staticClass: "mt-5 last:mb-5"
        }, [_c('DoubleInputTextWithAction', {
          ref: 'compTr' + lndex + 'criterion' + kndex,
          refInFor: true,
          style: 'cursor:grab',
          attrs: {
            "libelle-left": "Critère",
            "libelle-right": "Indicateur",
            "necessary": false,
            "value-left": criterion_transversales.name,
            "value-right": criterion_transversales.indicateur,
            "disabled": !_vm.editable,
            "is-grabable": true,
            "draggable": true,
            "prefix-text-left": kndex + 1 + '. ',
            "prefix-text-right": kndex + 1 + '. '
          },
          on: {
            "inputLeft": function (newValue) {
              criterion_transversales.name = newValue;
            },
            "inputRight": function (newValue) {
              criterion_transversales.indicateur = newValue;
            },
            "duplicate": function ($event) {
              _vm.form.modules[index].module_competences_transversales[lndex].push(criterion_transversales);
            },
            "delete": function ($event) {
              return _vm.deleteFromModule(_vm.form.modules[index].module_competences_transversales[lndex].criterion_transversales, kndex);
            },
            "switchEditable": function (state) {
              _vm.changeDraggableCriterionState('competence_transversales', _vm.compindex, _vm.jndex, state);
            }
          }
        })], 1);
      }), 0)], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "mx-5 md:mx-15 mt-10"
      }, [_vm.editable ? _c('div', {
        staticClass: "w-max col-start-2 mb-5",
        on: {
          "click": function ($event) {
            return _vm.deleteFromModule(_vm.form.modules[index].module_competences_transversales, lndex);
          }
        }
      }, [_c('delete-button', {
        attrs: {
          "libelle": "Supprimer la compétence"
        }
      })], 1) : _vm._e()])]) : _vm._e()])], 1);
    }), 0)], 1)], 1)])]);
  })], 2)])])], 1)], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }